import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, X, LogOut, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { clearAttorney } from "../lib/attorneyAuth";

/**
 * Renders a sticky banner whenever the persisted attorney session is flagged
 * as an admin impersonation. Click "Exit" → revokes the session, clears local
 * storage, and returns to /admin.
 */
export default function ImpersonationBanner({ impersonation, firm }) {
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);
  if (!impersonation?.is_impersonation) return null;

  const exit = async () => {
    setExiting(true);
    try { await api.post("/portal/exit-impersonation"); } catch { /* ignore */ }
    // Clear ALL attorney/impersonation state so the interceptor stops
    // attaching the X-Impersonate-Firm header on subsequent requests.
    clearAttorney();
    navigate("/admin", { replace: true });
  };

  return (
    <div className="bg-[#A16207] text-white px-4 py-2 text-xs sticky top-0 z-50 flex items-center justify-center gap-3 flex-wrap" data-testid="impersonation-banner">
      <Eye className="w-3.5 h-3.5" />
      <span className="font-medium tracking-wide">IMPERSONATION MODE</span>
      <span className="opacity-90">Viewing <strong>{firm?.name}</strong> as admin <strong>{impersonation.admin_email}</strong></span>
      <button onClick={exit} disabled={exiting} className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-white/15 hover:bg-white/25 transition-colors disabled:opacity-60" data-testid="exit-impersonation-btn">
        {exiting ? <Loader2 className="w-3 h-3 animate-spin" /> : <LogOut className="w-3 h-3" />}
        Exit
      </button>
    </div>
  );
}
